import { useState } from 'react';
import { Search } from 'react-feather';
import { useTranslation } from 'react-i18next';
import {
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import './SearchReseller.css';
import CustomTable from '../../CommonComponents/Table/CustomTable';
import { searchResellerService } from '../../Services/resellerServices';
import CustomPagination from '../../CommonComponents/Table/CustomPagination';
import Loader from '../../CommonComponents/Loader/Loader';
import ErrorToast from '../../CommonComponents/Toast/ErrorToast';

const SearchReseller = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');

  const [tableData, setTableData] = useState({
    rows: [],
    totalRecords: 0,
    totalPages: 0,
    pageNumber: 0,
  });

  const [errorMessage, setErrorMessage] = useState('');
  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [apiError, setApiError] = useState(null);
  const [openError, setOpenError] = useState(false);
  const [resultLoading, setResultLoading] = useState(false);

  const colheaders = [
    { key: 'name', name: t('companyName') },
    { key: 'address', name: t('reseller_label_address') },
    { key: 'alternativename', name: t('reseller_label_alternativename') },
    { key: 'identifiyingcountryName', name: t('reseller_label_identifyingcountry') },
    { key: 'remarks', name: t('remarks') },
    { key: 'divisionName', name: t('reseller_label_divisionalfocus') },
  ];

  const handleCloseError = (reason) => {
    if (reason === 'clickaway') return;
    setOpenError(false);
    setApiError(null);
  };

  const fetchResellers = async (search, pageNo) => {
    try {
      setResultLoading(true);
      const response = await searchResellerService(search, pageNo, pageSize);

      if (response.status === 200) {
        const result = response.data?.result;
        if (!result?.reseller || result.reseller.length === 0) {
          setErrorMessage(`${t('SYSTEM_ERROR_Search3')} (${search})`);
        } else {
          setErrorMessage('');
        }

        setTableData({
          rows: result?.reseller || [], 
          totalRecords: result?.totalNumberOfRecord || 0,
          totalPages: result?.numberOfPages || 1,
          pageNumber: result?.pageNumber || 0,
        });
      } else if (response.status === 207) {
        setErrorMessage(t('SYSTEM_ERROR_Search1'));
      }
    } catch (err) {
      console.error(err);
      setApiError(t('apiError'));
      setOpenError(true);
    } finally {
      setResultLoading(false);
    }
  };

  const handleSearch = () => {
    if (searchTerm.length < 3) {
      setErrorMessage(t('searchparInvalid'));
      return;
    }
    setPageNum(0); // reset to first page on new search
    fetchResellers(searchTerm, 0);
  };

  const handlePageChange = (pageNo) => {
    setPageNum(pageNo - 1); // 0-based
    fetchResellers(searchTerm, pageNo - 1);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  console.log('tableData:', tableData);

  return (
    <div className="searchWrapper">
      <Typography
        noWrap
        sx={{
          color: '#151C2D',
          fontSize: '1rem',
          fontStyle: 'normal',
          fontWeight: 600,
          fontFamily: 'Arial, Helvetica, sans-serif',
        }}
      >
        {t('navlevel1_1')}
      </Typography>
      <hr />
      <div className="searchInputWrapper">
        <div className="searchInput">
          <TextField
            variant="outlined"
            placeholder={t('searchparInvalid')}
            value={searchTerm}
            onKeyDown={handleKeyDown}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-input': { height: '100%', padding: '10px' },
              '& input::placeholder': { fontSize: '14px' },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleSearch}
                    edge="end"
                    sx={{ width: '34px' }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
          />
        </div>
        <div>
          <p className="error-text">{errorMessage}</p>
        </div>
      </div>

      <div className="searchTable">
        <CustomTable
          tableData={tableData?.rows}
          errorMessage={errorMessage}
          colheaders={colheaders}
        />
      </div>

      <br />

      <div className="pagination">
        {tableData?.rows?.length > 0 && (
          <CustomPagination
            total={tableData.totalRecords} 
            totalRecords={tableData.totalRecords}
            handlePageChange={handlePageChange}
            pageSize={pageSize}
            pageNo={pageNum}
            totalPages={tableData.totalPages}
          />
        )}
      </div>

      <p className="error-text">{t('footerresults')}</p>
      <br />
      <br />
      <ErrorToast
        open={openError}
        handleClose={handleCloseError}
        message={apiError}
      />
      <Loader open={resultLoading} text={'Loading'} />
    </div>
  );
};

export default SearchReseller;
